import React from "react";
import logo from "../logo.png";
import logosolid from "../logo-solid.png";
import imgbanner from "../image-banner-home6.png";
import noc from "../noc.jpg";
import foc from "../foc.jpg";
import am from "../am.jpg";
import { Link } from "react-router-dom";

function Career() {
  return (
    <>
      <div id="page" class="site">
        <header
          id="site-header"
          class="site-header header-style-1 home-6 header-overlay header-fullwidth sticky-header mobile-header-sticky"
        >
          <div class="octf-main-header">
            <div class="octf-area-wrap">
              <div class="container-fluid octf-mainbar-container">
                <div class="octf-mainbar">
                  <div class="octf-mainbar-row octf-row">
                    <div class="octf-col">
                      <div id="site-logo" class="site-logo">
                        <a href="/">
                          <img class="logo-static" src={logo} alt="Onum" />
                          <img class="logo-scroll" src={logo} alt="Onum" />
                        </a>
                      </div>
                    </div>

                    <div class="octf-col">
                      <nav id="site-navigation" class="main-navigation">
                        <ul id="primary-menu" class="menu">
                          <li class="">
                            <Link to="/">Home</Link>
                          </li>
                          <li class="">
                            <Link to="/#product">Products</Link>
                          </li>
                          <li class="">
                            <Link to="/#about">About</Link>
                          </li>
                          <li class="">
                            <Link to="/#contact">Contact</Link>
                          </li>
                          <li data-spy="scroll" class="current-menu-item current-menu-ancestor">
                            <a href="#career">Career</a>
                          </li>
                        </ul>
                      </nav>
                    </div>

                    <div class="octf-col text-right">
                      <div class="octf-btn-cta">
                        <div class="octf-header-module">
                          <div class="btn-cta-group">
                            <a
                              class="octf-btn octf-btn-primary"
                              href="tel:+622230501500"
                            >
                              <i class="fa fa-phone"></i>&nbsp; +62 22-3050 1500
                            </a>
                          </div>
                        </div>
                        <div class="octf-header-module">
                          <div class="btn-cta-group">
                            <a
                              class="octf-btn octf-btn-primary"
                              target="_blank"
                              href="mailto:sapa@urbanaccess.net"
                            >
                              <i class="fa fa-envelope"></i>&nbsp;
                              sapa@urbanaccess.net
                            </a>
                          </div>
                        </div>
                        <div class="octf-header-module">
                          <div class="toggle_search octf-cta-icons">
                            <i class="flaticon-search"></i>
                          </div>

                          <div class="h-search-form-field">
                            <div class="h-search-form-inner">
                              <form
                                target="_blank"
                                role="search"
                                method="get"
                                id="search-form"
                                class="search-form"
                                action="https://www.google.com/search?q=urbanaccess.net&oq=urbanaccess.net"
                              >
                                <input
                                  type="search"
                                  class="search-field"
                                  placeholder="Search…"
                                  value=""
                                  name="s"
                                />
                                <button type="submit" class="search-submit">
                                  <i class="flaticon-search"></i>
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="header_mobile">
            <div class="container">
              <div class="mlogo_wrapper clearfix">
                <div class="mobile_logo">
                  <a href="/">
                    <img src={logosolid} alt="Onum" />
                  </a>
                </div>

                <div id="mmenu_toggle">
                  <button></button>
                </div>
              </div>

              <div class="mmenu_wrapper">
                <div class="mobile_nav">
                  <ul id="menu-main-menu" class="mobile_mainmenu">
                    <li class="current-menu-item current-menu-ancestor">
                      <a href="/">Home</a>
                    </li>
                    <li class="">
                      <a href="#product">Products</a>
                    </li>
                    <li class="">
                      <a href="#about">About</a>
                    </li>
                    <li class="">
                      <a href="#contact">Contact</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div id="content" class="site-content">
          <section class="home6-top">
            <div class="container">
              <div class="flex-row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                  <div class="home6-top-img">
                    <img src={imgbanner} alt="" />
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                  <div class="home6-top-block">
                    <h6>U R B A N &nbsp; A C C E S S &nbsp; .net</h6>
                    <h2>Lowongan Tersedia.</h2>
                    <p>
                      Bergabunglah dengan tim kami untuk membuka peluang membangun karir.
                    </p>
                    
                  </div>
                </div>
              </div>
            </div>
          </section>

        <section class="home6-partners">
          <div class="container">
            <div class="glass-card">
              <div class="carousel">
                <div class="carousel-track">
                  <img src={noc} alt="NOC" />
                  <img src={foc} alt="FOC" />
                  <img src={am} alt="AM" />
                </div>
              </div>
            </div>
          </div>
        </section>

        </div>

        <footer
          id="site-footer"
          class="site-footer site-footer-2 bg-gradient-2"
        >
          <div class="footer-bottom"></div>
          <div class="container">
            <p class="copyright-2 text-center">
              {" "}
              Disclaimer : <br /> Harga yang tercantum dalam website dapat
              berubah sewaktu-waktu sesuai dengan syarat dan ketentuan yang
              berlaku.
              <br />
              Untuk informasi lebih lanjut, silakan hubungi Customer Care kami
              di +62 22 30501500 atau melalui email ke sapa@urbanaccess.net.{" "}
            </p>
            <p class="copyright-2 text-center">
              Copyright © 2022 UrbanAccess .NET
              
            </p>
          </div>
        </footer>
        <a id="back-to-top" href="#" class="show">
          <i class="flaticon-arrow-pointing-to-up"></i>
        </a>
      </div>
    </>
  );
}

export default Career;
